// ADD ACTION TYPES FOR EACH USED REPOSITORY
import * as actionTypes from '../Actions/actionTypes';
import * as sidebarActionTypes from '../Actions/sidebarActions';

// Application State
const initialState = {
    appTitle:"My Re-insurance APP",
    presentationMode:false,
    sidebarShow:true,
    isConnected: false,
    clients:[],
    language:"FR",
    loading:false,
    extendedModule:"",
    activeView:"Homepage",
    submenu:"",
    sidebarContent: [],
    nodes: {
      SECURITY:[
        // REPOSITORY
        {
          name:"Repository",
          config:{},
          children:[
            // DROITS D"ACCES
            {
              name:"Droits d'acces",
              type:"EN3",
              subType:"DDA",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
            // GROUPES D'UTILISATEURS
            {
              name:"Groupes d'utilisateurs",
              type:"EN3",
              subType:"TDG",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            }
          ],
          objects:[],
        },
        // PERMISSIONS
        {
          name:"Permissions",
          config:{},
          children:[
            //LISTES
            {
              name:"Listes",
              type:"EN3",
              subType:"PER",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
            // MODULES
            {
              name:"Modules",
              type:"EN3",
              subType:"ACM",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
            // MENUS
            {
              name:"Menus",
              type:"EN3",
              subType:"MEN",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            }
          ],
          objects:[],
        },
      ],
      PARAMETERS:[
        // REPOSITORY
        {
          name:"Repository",
          config:{},
          children:[
            // TDI
            {
              name:"TDI, type d'information",
              type:"TDI",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"ENTITY",
                    displayName:"Entity",
                    type:"Text"
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"TDI",
              objects:null,
            },
            // TYPE DE LIEN
            {
              name:"Type de Lien",
              type:"LNK",
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE_TDI",
                    displayName:"Code TDI",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"PARENT_TABLE",
                    displayName:"Parent table",
                    type:"Text",
                    choices:""
                  },
                  {
                    name:"PARENT_FIELD",
                    displayName:"Parent field",
                    type:"Text",
                    choices:""
                  },
                  {
                    name:"CHILD_TABLE",
                    displayName:"Child table",
                    type:"Text",
                    choices:""
                  },
                  {
                    name:"CHILD_FIELD",
                    displayName:"Child field",
                    type:"Text",
                    choices:""
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"LNK",
              objects:null,
              children:[],
            },
            // TYPE DE LIEN EN3
            {
              name:"Lien EN3",
              type:"EN3",
              subType:"LNKEN3",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
          ],
          objects:[],
        },
        // INVARIANTS
        {
          name:"Invariants",
          config:{},
          children:[
              // BOOLEANS
              {
                name:"Booleans",
                type:"EN3",
                subType:"BOOL",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // DEVISES
              {
                name:"Devises",
                type:"CURRENCY",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"ISO_4217_ALPHA3",
                      displayName:"ISO3",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"ISO_4217_NUMERIC",
                      displayName:"Number",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"SYMBOL",
                      displayName:"Symbol",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"CUR",
                objects:null,
              },
              // FRACTALS
              {
                name:"Fractionnements",
                type:"EN3",
                subType:"FRAC",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // LANGUES
              {
                name:"Langues",
                type:"EN3",
                subType:"LAN",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // FINANCIAL MODE
              {
                name:"Mode de financement",
                type:"EN3",
                subType:"MDP",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // MONTHS
              {
                name:"Months",
                type:"EN3",
                subType:"MOIS",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // NATIONALITY
              {
                name:"Nationalités",
                type:"EN3",
                subType:"NAT",
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"]
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
                children:[],
              },
              // SECTORS
              {
                name:"Sectors",
                type:"EN3",
                subType:"SCA",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // CONTRACT STATUS
              {
                name:"Contract Status",
                type:"EN3",
                subType:"SDP",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // GENDERS
              {
                name:"Genders",
                type:"EN3",
                subType:"SEXE",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // ADDRESS TYPE
              {
                name:"Address Type",
                type:"EN3",
                subType:"ADR",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // COUNTERPART TYPE
              {
                name:"Counterpart type",
                type:"EN3",
                subType:"TIE",
                children:[],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
              // NACECODE
              {
                name:"NACE",
                config:{},
                children:[
                    {
                        name:"NACE 01",
                        type:"EN3",
                        subType:"NA1",
                        config:{
                          id:"ARCS",
                          isSelectable:false,
                          columns:[
                            {
                              name:"CODE",
                              displayName:"Code",
                              type:"Text",
                              state:"ReadOnly",
                              unique:true,
                            },
                            {
                              name:"WORDING",
                              displayName:"Wording",
                              type:"Multi",
                              choices:["DE","EN","FR"]
                            },
                            {
                              name:"COMMENT",
                              displayName:"Comment",
                              type:"Text"
                            }
                          ],
                          actions:[
                            "Update",
                            "Archive",
                            "Add",
                          ]
                        },
                        endpoint:"EN3",
                        objects:null,
                        children:[
                            {
                                name:"NACE 02",
                                type:"EN3",
                                parent:"NA1",
                                subType:"NA2",
                                config:{
                                  id:"ARCS",
                                  isSelectable:false,
                                  columns:[
                                    {
                                      name:"CODE",
                                      displayName:"Code",
                                      type:"Text",
                                      state:"ReadOnly",
                                      unique:true,
                                    },
                                    {
                                      name:"WORDING",
                                      displayName:"Wording",
                                      type:"Multi",
                                      choices:["DE","EN","FR"]
                                    },
                                    {
                                      name:"COMMENT",
                                      displayName:"Comment",
                                      type:"Text"
                                    }
                                  ],
                                  actions:[
                                    "Update",
                                    "Archive",
                                    "Add",
                                  ]
                                },
                                endpoint:"EN3",
                                objects:null,
                                children:[
                                    {
                                        name:"NACE 03",
                                        type:"EN3",
                                        subType:"NA3",
                                        parent:"NA2",
                                        config:{
                                          id:"ARCS",
                                          isSelectable:false,
                                          columns:[
                                            {
                                              name:"CODE",
                                              displayName:"Code",
                                              type:"Text",
                                              state:"ReadOnly",
                                              unique:true,
                                            },
                                            {
                                              name:"WORDING",
                                              displayName:"Wording",
                                              type:"Multi",
                                              choices:["DE","EN","FR"]
                                            },
                                            {
                                              name:"COMMENT",
                                              displayName:"Comment",
                                              type:"Text"
                                            }
                                          ],
                                          actions:[
                                            "Update",
                                            "Archive",
                                            "Add",
                                          ]
                                        },
                                        endpoint:"EN3",
                                        objects:null,
                                        children:[
                                            {
                                                name:"NACE 04",
                                                type:"EN3",
                                                subType:"NA4",
                                                parent:"NA3",
                                                config:{
                                                  id:"ARCS",
                                                  isSelectable:false,
                                                  columns:[
                                                    {
                                                      name:"CODE",
                                                      displayName:"Code",
                                                      type:"Text",
                                                      state:"ReadOnly",
                                                      unique:true,
                                                    },
                                                    {
                                                      name:"WORDING",
                                                      displayName:"Wording",
                                                      type:"Multi",
                                                      choices:["DE","EN","FR"]
                                                    },
                                                    {
                                                      name:"COMMENT",
                                                      displayName:"Comment",
                                                      type:"Text"
                                                    }
                                                  ],
                                                  actions:[
                                                    "Update",
                                                    "Archive",
                                                    "Add",
                                                  ]
                                                },
                                                endpoint:"EN3",
                                                objects:null,
                                                children:[],
                                              }
                                        ],
                                      }
                                ],
                              }
                        ],
                      }
                ],
              },
              // CONTINENTS
              {
                name:"Continents",
                type:"EN3",
                subType:"CTN",
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                children:[
                  // PAYS
                  {
                    name:"Pays",
                    type:"PAYS",
                    parent:"CTN",
                    //subType:"LAN",
                    children:[
                      // GEOGRAPHIC ZONE
                      {
                        name:"Geographic zone",
                        type:"EN3",
                        subType:"ZG",
                        parent:"PAYS",
                        config:{
                          id:"ARCS",
                          isSelectable:false,
                          columns:[
                            {
                              name:"CODE",
                              displayName:"Code",
                              type:"Text",
                              state:"ReadOnly",
                              unique:true,
                            },
                            {
                              name:"WORDING",
                              displayName:"Wording",
                              type:"Multi",
                              choices:["DE","EN","FR"]
                            },
                            {
                              name:"COMMENT",
                              displayName:"Comment",
                              type:"Text"
                            }
                          ],
                          actions:[
                            "Update",
                            "Archive",
                            "Add",
                          ]
                        },
                        endpoint:"EN3",
                        objects:null,
                        children:[],
                      },
                      // LEGAL FORMS
                      {
                        name:"Legal Forms",
                        type:"EN3",
                        subType:"FJ",
                        parent:"PAYS",
                        config:{
                          id:"ARCS",
                          isSelectable:false,
                          columns:[
                            {
                              name:"CODE",
                              displayName:"Code",
                              type:"Text",
                              state:"ReadOnly",
                              unique:true,
                            },
                            {
                              name:"WORDING",
                              displayName:"Wording",
                              type:"Multi",
                              choices:["DE","EN","FR"]
                            },
                            {
                              name:"COMMENT",
                              displayName:"Comment",
                              type:"Text"
                            }
                          ],
                          actions:[
                            "Update",
                            "Archive",
                            "Add",
                          ]
                        },
                        endpoint:"EN3",
                        objects:null,
                        children:[],
                      },
                      // SALARY INDEX
                      {
                        name:"Salary Index",
                        type:"EN3",
                        subType:"INDSAL",
                        parent:"PAYS",
                        config:{
                          id:"ARCS",
                          isSelectable:false,
                          columns:[
                            {
                              name:"CODE",
                              displayName:"Code",
                              type:"Text",
                              state:"ReadOnly",
                              unique:true,
                            },
                            {
                              name:"WORDING",
                              displayName:"Wording",
                              type:"Multi",
                              choices:["DE","EN","FR"]
                            },
                            {
                              name:"COMMENT",
                              displayName:"Comment",
                              type:"Text"
                            }
                          ],
                          actions:[
                            "Update",
                            "Archive",
                            "Add",
                          ]
                        },
                        endpoint:"EN3",
                        objects:null,
                        children:[],
                      },
                    ],
                    config:{
                      id:"ARCS",
                      isSelectable:false,
                      columns:[
                        {
                          name:"ISO_3166_1_ALPHA2",
                          displayName:"ISO 2",
                          type:"Text",
                          state:"ReadOnly",
                          unique:true,
                          limit:2,
                        },
                        {
                          name:"ISO_3166_1_ALPHA3",
                          displayName:"ISO 3",
                          type:"Text",
                          unique:true,
                          limit:3,
                        },
                        {
                          name:"ISO_3166_1",
                          displayName:"ISO 3166",
                          type:"Text",
                          unique:true,
                          mask:"99999",
                        },
                        {
                          name:"WORDING",
                          displayName:"Wording",
                          type:"Text",
                        },
                        {
                          name:"CAPITAL",
                          displayName:"Capital",
                          type:"Text"
                        },
                        {
                          name:"INDICATIF",
                          displayName:"Indicatif",
                          type:"Text",
                          mask:"+999",
                        },
                        {
                          name:"DOMAINE",
                          displayName:"Domaine",
                          type:"Text",
                        },
                        {
                          name:"SUPERFICIE_KM2",
                          displayName:"Superficie Km2",
                          type:"Text",
                        },
                        {
                          name:"FILE",
                          displayName:"File",
                          type:"File",
                        },
                      ],
                      actions:[
                        "Update",
                        "Archive",
                        "Add",
                      ]
                    },
                    endpoint:"PAYS",
                    objects:null,
                  },
                ],
                endpoint:"EN3",
                objects:null,
              },
              
              // ZRE
              {
                name:"Economic group zone",
                type:"EN3",
                subType:"ZRE",
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                children:[
                  // SUB ZRE
                  {
                    name:"Sub Economic group zone",
                    type:"EN3",
                    subType:"ZRE1",
                    children:[],
                    config:{
                      id:"ARCS",
                      isSelectable:false,
                      columns:[
                        {
                          name:"CODE",
                          displayName:"Code",
                          type:"Text",
                          state:"ReadOnly",
                          unique:true,
                        },
                        {
                          name:"WORDING",
                          displayName:"Wording",
                          type:"Multi",
                          choices:["DE","EN","FR"],
                        },
                        {
                          name:"COMMENT",
                          displayName:"Comment",
                          type:"Text"
                        }
                      ],
                      actions:[
                        "Update",
                        "Archive",
                        "Add",
                      ]
                    },
                    endpoint:"EN3",
                    objects:null,
                  },
                ],
              },
              // ORGANISATIONS
              {
                name:"Organisations",
                type:"EN3",
                subType:"ORG",
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Multi",
                      choices:["DE","EN","FR"],
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                children:[
                  // SUB ORGANISATIONS
                  {
                    name:"Sub Organisations",
                    type:"EN3",
                    subType:"ORG1",
                    children:[],
                    config:{
                      id:"ARCS",
                      isSelectable:false,
                      columns:[
                        {
                          name:"CODE",
                          displayName:"Code",
                          type:"Text",
                          state:"ReadOnly",
                          unique:true,
                        },
                        {
                          name:"WORDING",
                          displayName:"Wording",
                          type:"Multi",
                          choices:["DE","EN","FR"],
                        },
                        {
                          name:"COMMENT",
                          displayName:"Comment",
                          type:"Text"
                        }
                      ],
                      actions:[
                        "Update",
                        "Archive",
                        "Add",
                      ]
                    },
                    endpoint:"EN3",
                    objects:null,
                  },
                ],
              },
          ]
        },
        // COUNTERPARTS
        {
          name:"Counter Parts",
          config:{},
          children:[
            // TIERS
            {
              name:"Tiers",
              type:"EN3",
              subType:"CTI",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
            // TIERS GESTION
            {
              name:"Tiers intervenants dans la gestion d'une société",
              type:"EN3",
              subType:"CTS",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
          ],
        },
      ],
      REFERENTIAL:[
         // COUNTERPART
         {
          name:"Counter Part",
          config:{},
          children:[
            // SOCIETES EN GESTION
            {
              name:"Societes en gestion",
              type:"EN3",
              subType:"CTI",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comments",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            },
          ],
          objects:[],
        },
      ],
      HR:[
        // REPOSITORY
        {
         name:"Repository",
         config:{},
         children:[
           // TITLES
           {
             name:"Titles",
             type:"EN3",
             subType:"TIT",
             children:[],
             config:{
               id:"ARCS",
               isSelectable:false,
               columns:[
                 {
                   name:"CODE",
                   displayName:"Code",
                   type:"Text",
                   state:"ReadOnly",
                   unique:true,
                 },
                 {
                   name:"WORDING",
                   displayName:"Wording",
                   type:"Text"
                 },
                 {
                   name:"COMMENT",
                   displayName:"Comment",
                   type:"Text"
                 }
               ],
               actions:[
                 "Update",
                 "Archive",
                 "Add",
               ]
             },
             endpoint:"EN3",
             objects:null,
           },
           // COMPANIES
           {
            name:"Companies",
            type:"EN3",
            subType:"ENT",
            children:[
              // EMPLOYEES
              {
                name:"Employees",
                type:"EN3",
                subType:"EMP",
                children:[

                ],
                config:{
                  id:"ARCS",
                  isSelectable:false,
                  columns:[
                    {
                      name:"CODE",
                      displayName:"Code",
                      type:"Text",
                      state:"ReadOnly",
                      unique:true,
                    },
                    {
                      name:"WORDING",
                      displayName:"Wording",
                      type:"Text"
                    },
                    {
                      name:"COMMENT",
                      displayName:"Comment",
                      type:"Text"
                    }
                  ],
                  actions:[
                    "Update",
                    "Archive",
                    "Add",
                  ]
                },
                endpoint:"EN3",
                objects:null,
              },
            ],
            config:{
              id:"ARCS",
              isSelectable:false,
              columns:[
                {
                  name:"CODE",
                  displayName:"Code",
                  type:"Text",
                  state:"ReadOnly",
                  unique:true,
                },
                {
                  name:"WORDING",
                  displayName:"Wording",
                  type:"Text"
                },
                {
                  name:"COMMENT",
                  displayName:"Comment",
                  type:"Text"
                }
              ],
              actions:[
                "Update",
                "Archive",
                "Add",
              ]
            },
            endpoint:"EN3",
            objects:null,
           },
         ],
         objects:[],
       },
     ],
      DOCUMENTS:[
        // REPOSITORY
        {
          name:"Repository",
          config:{},
          children:[
            {
              name:"Types de documents",
              type:"EN3",
              subType:"TDD",
              children:[],
              config:{
                id:"ARCS",
                isSelectable:false,
                columns:[
                  {
                    name:"CODE",
                    displayName:"Code",
                    type:"Text",
                    state:"ReadOnly",
                    unique:true,
                  },
                  {
                    name:"WORDING",
                    displayName:"Wording",
                    type:"Text"
                  },
                  {
                    name:"COMMENT",
                    displayName:"Comment",
                    type:"Text"
                  }
                ],
                actions:[
                  "Update",
                  "Archive",
                  "Add",
                ]
              },
              endpoint:"EN3",
              objects:null,
            }
          ],
          objects:[],
        },
        // DOCUMENTS
        {
          name:"Documents",
          type:"DOC",
          //subType:"DOC",
          children:[],
          config:{
            id:"ARCS",
            isSelectable:false,
            columns:[
              {
                name:"WORDING",
                displayName:"Wording",
                type:"Text"
              },
              {
                name:"FRMT",
                displayName:"Format",
                type:"Text"
              },
              {
                name:"INFORMATION",
                displayName:"Information",
                type:"Text"
              }
            ],
            actions:[
              "Update",
              "Archive",
              "Add",
            ]
          },
          endpoint:"DOC",
          objects:null,
        },
      ],
    },
    currentNode:{},
    modulesData:[],
    
}

// NAVIGATION METHOD
const switchActiveView = (state,action) =>{
  var activeView = action.data;
  var stateTmp = {...state};
  stateTmp.activeView = activeView;

  return stateTmp;
}
const updateAppStructure = (state,action) =>{
  var stateTmp = {...state};
  var structure = action.data;
  stateTmp.sidebarContent = structure;

  return stateTmp;
}

const updateClientList = (state,action) =>{
  var stateTmp = {...state};
  var clients = action.data;

  stateTmp.clients = clients;

  return stateTmp;
}

const updateSubmenu=(state,action)=>{
  var stateTmp = {...state};
  stateTmp.submenu = action.data;

  return stateTmp;
}

// MODULES METHOD
const updateExpandedModule = (state, action) => {
    console.log("EXPAND MODULE",action.data.type);
    if(state.extendedModule === action.data.type){
      state.extendedModule = "";
    }else{
      state.extendedModule = action.data.type;
    }
    return { ...state };
}

const registerModule = (state, action) => {

  if(state.modulesData[action.data.type]){
    console.log("already registered",state.modulesData);
  }else{
    console.log("registering module",action.data.type);
    state.modulesData[action.data.type] = [];
  }


  return { ...state };
}

const onAddModuleData = (state, action)=>{
  var modulesData = {...state.modulesData};
  var stateTmp = {...state};
  console.log("modulesData",modulesData);
  modulesData[action.data.type].push(action.data.data);
  stateTmp.modulesData = modulesData;

  return stateTmp;
}

const onUpdateModuleData = (state, action)=>{
  var modulesData = {...state.modulesData};
  var stateTmp = {...state};
  modulesData[action.data.type] = action.data.data;
  stateTmp.modulesData = modulesData;
  return stateTmp;
}



//
const toggleSidebar = (state, action)=>{
  state.sidebarShow = !state.sidebarShow;
  return {...state};
}

const switchSidebarItem = (state, action) => {
  var dataContent = [...state.sidebarContent];
  var viewName = "";
  for (let i = 0; i < dataContent.length; i++) {
      if (i === action.data.i) {
          dataContent[i].isActive = true;
          viewName = dataContent[i].name;
          dataContent[i].isExpendable = true;
          if (dataContent[i].children.length > 0) {
              for (let j = 0; j < dataContent[i].children.length; j++) {

                  if (j === action.data.j) {
                      dataContent[i].children[j].isActive = true;
                      
                  } else {
                      dataContent[i].children[j].isActive = false;
                  }
              }

          }


      } else {
          dataContent[i].isActive = false;
          dataContent[i].isExpendable = false;
      }
  }
  state.activeView = viewName;
  state.sidebarContent = dataContent;
  return { ...state };
}

const toggleConnect = (state, action) => {
  state.isConnected = !state.isConnected;
  state.loginIsExtended = false;
  state.notificationIsExtended = false;
  return { ...state };
}

const togglePresentationMode = (state, action)=>{
    var stateTmp = {...state};
    stateTmp.presentationMode = !state.presentationMode;
    if (stateTmp.presentationMode) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen()
      }
    return stateTmp;
}

const onStartLoader = (state, action)=>{
    state.loading = true
    return {...state};
}

const onStopLoader = (state, action)=>{
    state.loading = false
    return {...state};
}

const setCurrentMode = (state,action)=>{
    state.currentNode = action.data;
    return {...state};
}

const updateNodesStructure = (state, action) =>{
    var nodes = {...state.nodes};
    // var children = [];
    // var regex = /(.*<<)(.*)(>>.*)/g;
    // var folders = [...new Set(action.data.filter(item=>item.ENTITY.length>0).map(item=>{return item.ENTITY}))];

    // console.log("updateNodesStructure",folders,nodes);

    // children = folders.map((item,i)=>{

    //     return {
    //         name:item.replace("F_",""),
    //         children:action.data.filter(data=>data.ENTITY === item).map(child=>{
    //             return {
    //                 name:[...child.WORDING.matchAll(regex)].length>0?[...child.WORDING.matchAll(regex)][0][2]:child.WORDING,
    //                 children:[],
    //                 endpoint:"WCFWindowsArcs/EN3ECLoad",
    //                 N3Id: child.ARCS,
    //             }
    //         }),
    //     }
    // });
    // action.data.filter(item=>item.ENTITY.length===0).forEach(element => {
    //     children.push({
    //        name:[...element.WORDING.matchAll(regex)].length>0?[...element.WORDING.matchAll(regex)][0][2]:element.WORDING,
    //        endpoint:"WCFWindowsArcs/EN3ECLoad",
    //        N3Id: element.ARCS,
    //        children:[]
    //     });
    // });
    // var node = {
    //     name:"Data List",
    //     children:children,
    // };
    // nodes.push(node);
    // state.nodes = nodes;
     return {...state};
}

// PAGINATION
////

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        //NAVIGATION
        case actionTypes.SWITCH_VIEW:
            return switchActiveView(state,action);
        case actionTypes.UPDATE_APP_STRUCTURE:
            return updateAppStructure(state,action);
        case actionTypes.UPDATE_CLIENTS_LIST:
            return updateClientList(state,action);
        case actionTypes.UPDATE_SUBLEVEL:
            return updateSubmenu(state,action);
        //LOGIN
        case actionTypes.TOGGLE_CONNECT:
            return toggleConnect(state, action);
        // MODULE
        case actionTypes.REGISTER_MODULE:
            return registerModule(state, action);
        case actionTypes.UPDATE_MODULE_EXPAND:
            return updateExpandedModule(state, action);
        case actionTypes.MODULE_ADD_DATA:
            return onAddModuleData(state,action);
        case actionTypes.MODULE_UPDATE_DATA:
            return onUpdateModuleData(state,action);
        //
        case sidebarActionTypes.TOGGLE_SIDEBAR:
            return toggleSidebar(state, action);
        case sidebarActionTypes.SWITCH_ITEM:
            return switchSidebarItem(state, action);
        case actionTypes.PRESENTATION_MODE:
            return togglePresentationMode(state,action);
        case actionTypes.START_LOADING:
            return onStartLoader(state,action);
        case actionTypes.STOP_LOADING:
            return onStopLoader(state,action);
        case actionTypes.POST_TDI_RETURN:
            return updateNodesStructure(state,action);
        case actionTypes.SET_CURRENT_NODE:
            return setCurrentMode(state,action);
        default:
            return { ...state}
    }
}



export default appReducer;